import React from 'react'
import Select from 'react-select';
import { commonActions } from '../../../_actions/common.actions';



class Dropdown extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      placeholder: this.props.placeholder ? this.props.placeholder : "Select..."
    }
  }

  componentDidUpdate(prev) {
    if (prev.placeholder !== this.props.placeholder) {
      this.setState({
        placeholder: this.props.placeholder ? this.props.placeholder : "Select..."
      })
    }
  }
  render() {
    let selectedvalue = commonActions.getSelectedValue(this.props.preselected, this.props.options)
    let isDisabled = this.props.isDisabled ? this.props.isDisabled : false

    const colourStyles = {
      control: styles => ({
        ...styles,
        backgroundColor: isDisabled ? "#E9ECEF" : "white",
        color: 'hsl(0,0%,50%)'
      }),
      option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? "white" : "",
        fontSize: 14,
        backgroundColor: state.isSelected ? "#134285" : "",
        textAlign: "left",
        cursor: "pointer",
        ...this.props.sstyle
      }),
      input: styles => ({ ...styles }),
      placeholder: styles => ({ ...styles }),
      singleValue: (styles) => ({ ...styles }),
    };



    return (
      <Select menuPlacement={this.props.OpenMenuDown ? "bottom" : this.props.OpenMenu ? "auto" : "top"} className={this.props.className} placeholder={this.state.placeholder} isDisabled={isDisabled} styles={colourStyles} value={selectedvalue} onChange={this.props.onChange} options={this.props.options}
        onKeyDown={this.props.onKeyPress}
        onInputChange={this.props.handleInputChange}
        {...this.props.otherOptions}
      />
    );
  }
}
export default Dropdown